// extracted by mini-css-extract-plugin
module.exports = {"nameHolder":"NameHolder_nameHolder__zrNwM"};